import { chainManager } from '../ChainManager';

export async function createCampaignViaChainManager(
  numMint: number,
  extraToken: string,
  extraTokenAmount: string,
  receivers: string[],
  value: number,
  lixiBagAddress: string,
): Promise<any> {
  const adapter = chainManager.getCurrentAdapter();
  if (!adapter?.createCampaign) throw new Error('Adapter chưa hỗ trợ createCampaign');
  
  // Validate receivers length for Solana chain
  // Note: buy_tickets_auto allows empty receivers (receivers can be added later via claim or whitelist)
  // But receivers.length must not exceed numMint if provided
  if (adapter.chain === 'solana') {
    // Receivers is optional for buy_tickets_auto - can be empty array
    // Only validate if receivers are provided
    if (receivers.length > 0) {
    if (receivers.length > numMint) {
      throw new Error(
        `Receivers count (${receivers.length}) cannot exceed number of tickets (${numMint}). ` +
        `Please reduce the number of receivers or increase the number of tickets.`
      );
    }
      // Note: Rust code allows receivers.length <= numTickets
    if (receivers.length < numMint) {
      console.warn(
        `[createCampaignViaChainManager] Receivers length (${receivers.length}) ` +
        `is less than numMint (${numMint}). ` +
          `Rust program allows this. Receivers can be added later via claim or whitelist.`
      );
      }
    }
    // If receivers.length === 0, that's allowed - receivers can be added later
  }
  
  return adapter.createCampaign({
    numMint,
    extraToken,
    extraTokenAmount,
    receivers,
    value,
    lixiBagAddress,
  });
}
